module.exports = __webpack_public_path__ + "static/media/1.b2f16f92.jpg";